import { FieldType, NumericComparator } from 'modules/domains/segmentation';
import { ClientDataType } from 'modules/queryBuilder/types';
import { createSearchQueryWithSingleRequirement } from 'modules/segmentation/navigation/utils';

export const createSegmentationSearchQuery = (criteriaId: number) =>
  createSearchQueryWithSingleRequirement(ClientDataType.User, [
    {
      dataType: ClientDataType.User,
      field: 'itblInternal.matchedCriteriaId',
      fieldType: FieldType.INTEGER,
      comparatorType: NumericComparator.EQUALS,
      value: criteriaId.toString(),
    },
  ]);
